import { ChevronDownIcon } from '@heroicons/react/24/solid'
import classNames from 'classnames'
import { type FC } from 'react'

export const SelectDropdownIcon: FC<{ isDisabled: boolean; onClick: () => void }> = ({ onClick, isDisabled }) => {
  return (
    <ChevronDownIcon
      onClick={() => {
        if (!isDisabled) {
          onClick()
        }
      }}
      className={classNames('ml-2 h-5 w-5 text-gray-400', {
        'cursor-not-allowed touch-none': isDisabled,
        'cursor-pointer': !isDisabled,
      })}
    />
  )
}
